export default {
  maxDuration: 12,
  multiCarrier: true
}
